module.exports = __webpack_public_path__ + "static/media/bg_18.6d657a08.png";